import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'Store';
import Admin from './App';
import './assets/scss/common.scss';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.render(
  <Provider store={ store }>
    <Admin />
  </Provider>,
  document.getElementById('root')
);
